export default __webpack_public_path__ + "static/media/footer-tablet.8afffb67.png";